import React, { createContext } from 'react'

type AppConfigProps = { children: React.ReactNode }

export interface AppConfig {
  features: {
    savedQuoteRedirect: string
  }
}

export const AppConfigContext = createContext<AppConfig>({} as AppConfig)

function AppConfigProvider({ children }: AppConfigProps) {
  const value: AppConfig = {
    features: {
      savedQuoteRedirect: process.env.REACT_APP_FEATURE_SAVED_QUOTE_REDIRECT,
    },
  }
  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  )
}

function useAppConfig() {
  const context = React.useContext(AppConfigContext)
  if (context === undefined) {
    throw new Error('useAppConfig must be used within a AppConfigProvider')
  }
  return context
}

export { AppConfigProvider, useAppConfig }
